import trim from "./trim";
//@ts-ignore
import { PhoneNumberUtil } from "google-libphonenumber";

export const getRequiredRules = (label: string, requiredMessage?: string) => {
  const message = requiredMessage ?? `${label}_is_required`;
  const validate = (value: string) => {
    if (value?.trim()) {
      return true;
    }
    return message;
  };

  return {
    validate,
  };
};

export const getEmailValidationRules = (
  required: boolean = true,
  label?: string
) => {
  const validateEmail = (value?: string) => {
    if (!trim(value) && required) {
      return label ? `${label}_is_required` : "Email_address_is_required";
    }
    return true;
  };
  return {
    validate: validateEmail,
    pattern: {
      value: /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
      message: label ? `${label}_is_invalid` : "Email_address_is_invalid",
    },
  };
};

export const getPasswordValidationRules = (label?: string) => {
  const validatePassword = (value: string) => {
    if (!value) {
      return "Password required";
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{8,}$/;

    if (!passwordRegex.test(value)) {
      return "Password entered does not meet requirements";
    }
    return true;
  };

  return {
    validate: validatePassword,
  };
};

export const getConfirmPasswordValidationRules = (
  password: string,
  label?: string
) => {
  const validate = (value: string) => {
    if (value !== password) {
      return label ?? "Password_does_not_match";
    }
    return true;
  };
  return {
    validate,
  };
};

export const getOnlyNumberValidation = (
  label?: string,
  requiredMessage?: string
) => {
  const message = requiredMessage ?? `Invalid_${label}`;
  return {
    pattern: {
      value: /^\d+$/,
      message,
    },
  };
};

const phoneUtil = PhoneNumberUtil.getInstance();

export const isValidNumber = (phoneNumber: string) => {
  try {
    if (phoneNumber.includes(".")) {
      return false;
    }
    const phone = phoneUtil.parse(phoneNumber);
    return phoneUtil.isValidNumber(phone);
  } catch {
    return false;
  }
};

export const getPhoneNumberValidationRules = (
  countryCode: string,
  requiredMessage?: string
) => {
  const validatePhone = (value?: string) => {
    if (trim(value)) {
      const countryCodePrefix = countryCode ? "+" : "";
      const fullNumber = `${countryCodePrefix}${countryCode}${value}`;
      if (isValidNumber(fullNumber)) {
        return true;
      }
      return requiredMessage ?? "Invalid Mobile Number";
    }
    return true;
  };
  return {
    validate: validatePhone,
  };
};
